import styled from 'styled-components';
import * as colors from '../../../../config/Colors/Ligth';

export const ContainerFiltros = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
  border-radius: 4px;
  margin: 10px 0;
  padding: 10px;
  border: 1px solid ${colors.borderColor};

  > div:first-child {
    display: flex;
    align-items: center;
    justify-content: center;
    h1 {
      font-size: 20px;
      padding-bottom: 10px;
    }
  }

  & > div {
    margin: 0;
    padding: 0;
    width: 100%;
    flex-direction: row;
    align-items: center;
    h2 {
      padding-right: 5px;
      color: ${colors.labelFontColor};
      padding-left: 5px;
      font-weight: 400;
      font-size: 10px;
    }
    margin-bottom: 10px;
  }
  label {
    font-size: 10px;
    color: ${colors.labelFontColor};
  }
`;

export const ContainerBotoes = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
`;

export const ContainerResumoFiltros = styled.div`
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  p {
    font-size: 10px;
  }
  padding-bottom: 10px;
`;

export const SecaoPreco = styled.div`
  display: flex;
  flex-direction: column;
  gap: 6px;
  width: 100%;
  margin-top: 0;
  padding: 15px;

  > div {
    margin-bottom: 0;
  }

  /* Garantir que os inputs tenham fundo branco */
  .react-select__control,
  input,
  .MuiFormControl-root {
    background-color: #fff !important;
  }

  @media (max-width: 768px) {
    padding: 10px 12px;
    gap: 6px;
  }
`;

export const TextoDescricao = styled.p`
  font-size: 12px;
  color: ${colors.ligthFontColor};
  margin: 0;
  margin-top: 4px;
  margin-bottom: 6px;

  @media (max-width: 768px) {
    font-size: 11px;
    margin-top: 3px;
    margin-bottom: 6px;
  }
`;

export const CaixaInformacao = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 14px;
  background-color: #fff3cd;
  border-radius: 6px;
  border: 1px solid #ffc107;
  margin-top: 10px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);

  svg {
    color: #ff9800;
    font-size: 20px;
    flex-shrink: 0;
  }

  p {
    font-size: 13px;
    color: #856404;
    margin: 0;
    font-weight: 500;
    line-height: 1.4;
  }

  @media (max-width: 768px) {
    padding: 12px;
    gap: 10px;
    margin-top: 8px;

    svg {
      font-size: 18px;
    }

    p {
      font-size: 12px;
    }
  }
`;
